import _ from 'lodash'

export default {
  extractProperties(groups, builderCallback) {
    let properties = groups.map(group => group.properties.map(builderCallback))
    let flattened = _.flatten(properties)
    return _.uniqBy(flattened, function (e) {
      return e.value;
    })
  }
}



// WEBPACK FOOTER //
// ./scripts/models/group.js